/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DevicesBulkAssignmentTenantResponseDto } from './DevicesBulkAssignmentTenantResponseDto';
import type { TenantDevicesBulkAssignmentDetails } from './TenantDevicesBulkAssignmentDetails';
export type DevicesBulkAssignmentInfoResponseDto = {
  id: number;
  tenant: DevicesBulkAssignmentTenantResponseDto;
  status: DevicesBulkAssignmentInfoResponseDto.status;
  createdBy: string;
  updatedAt: string;
  createdAt: string;
  completedAt: string;
  details: TenantDevicesBulkAssignmentDetails;
};
export namespace DevicesBulkAssignmentInfoResponseDto {
  export enum status {
    NEW = 'NEW',
    ENDED = 'ENDED',
    ERROR = 'ERROR',
  }
}

